const searchFiles = (file, searchTerm) => {
  let found = [];

  if (file.fileName.match(searchTerm) && !file.folder) {
    found.push(file);
  }

  if (file.folder) {
    for (const child of file.children) {
      const childFound = searchFiles(child, searchTerm);
      found = [...found, ...childFound];
    }
  }

  return found;
};

export default searchFiles;



// WEBPACK FOOTER //
// ./src/utility/searchFiles.js